import { render, staticRenderFns } from "./TaskUndone.vue?vue&type=template&id=a15441be&"
import script from "./TaskUndone.vue?vue&type=script&lang=js&"
export * from "./TaskUndone.vue?vue&type=script&lang=js&"
import style0 from "./TaskUndone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports